import React from "react";

import { useEffect, useState, useCallback } from "react";
import Search from "./search";

import { CgClose } from "react-icons/cg";
import Products from "../products";
import Proceed from "../proceed";
import ProductMaleFemale from "../productmalefemale";

function SearchProduct(props) {

  const [products, setProducts] = useState([]);

  const [searchQuery, setsearchQuery] = useState("");

  const callback = useCallback(() => {
    document.body.style.overflow = "unset";
    props.setIsProductMale(false)
  })

  useEffect(() => {
    return callback
  }, []);

  const cancel = () => {
    props.setIsSearchProducts(false);
    document.body.style.overflow = "unset";
  };

  useEffect(() => {
    if (searchQuery != "") {
      setProducts(
        props.gotProducts.data.products.filter((item) => {
          if (item.name.toLowerCase().includes(searchQuery.toLowerCase())) {
            return item
          }

        })
      );
    } else {
      setProducts([]);
    }
  }, [searchQuery, props]);

  return (
    <div
      className="search-product-page d-flex flex-column justify-content-between h-100"
    >
      <div>
        <div className="header-search-container">
          <div className="header d-flex justify-content-between align-items-center">
            <p className="title mb-0">Search</p>
            <button
              onClick={() => {
                cancel();
              }}
              className="back"
            >
              <CgClose />
            </button>
          </div>
          <ProductMaleFemale salon={props.salon} setIsProductMale={props.setIsProductMale}
            setIsProductFemale={props.setIsProductFemale} />
          <Search setsearchQuery={setsearchQuery} />
        </div>

        {products.length > 0 ? (
          <Products
            isProceed={props.isProceed}
            isSearchProducts={props.isSearchProducts}
            getGenericCart={props.getGenericCart}
            setIsPopUp={props.setIsPopUp}
            setPopUpMessage={props.setPopUpMessage}
            salon={props.salon}
            getCartList={props.getCartList}
            productCategoryName={props.productCategoryName}
            products={products}

          />
        ) : (
          <>{searchQuery.length > 0 ? <p className="message">No result</p> : ""}</>
        )}
      </div>
      {props.gotCartList && props.gotCartList.data.cart && props.gotCartList.data.cart.cartCalculations.overall.totalItems > 0 || props.gotGenericCart && props.gotGenericCart.data.genericCart && props.gotGenericCart.data.genericCart.cartCalculations.overall.totalItems > 0 ? (
        <Proceed gotGenericCart={props.gotGenericCart} gotCartList={props.gotCartList} />
      ) : (
        ""
      )}
    </div>
  );
}

export default SearchProduct;
